import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ImpressumPage } from './impressum';

@NgModule({
  declarations: [
    ImpressumPage,
  ],
  imports: [
    IonicPageModule.forChild(ImpressumPage),
  ],
})
export class ImpressumPageModule {}



// WEBPACK FOOTER //
// ./src/pages/impressum/impressum.module.ts